import { render, staticRenderFns } from "./AtualizacaoCadastralDetalhar.vue?vue&type=template&id=41edaa77&"
import script from "./AtualizacaoCadastralDetalhar.vue?vue&type=script&lang=js&"
export * from "./AtualizacaoCadastralDetalhar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports